import {
  getUserAnalyticsObject,
  isShowAnalyticsEventLoaded,
  sanitizeTextForAnalytics,
} from "@/utils/helper"
import { mapCollapsedSku } from "@/utils"
import { PAGE_TYPES, NAVIGATION_TYPE } from "@/constants/index"

export const analyticsCB = (status, cartObjData = {}) => {
  const { itemSkus = [], ...cartObj } = cartObjData
  const page = window.pageObj || {}
  if (status !== "success" && page.eventInfo) {
    page.eventInfo.eventStatus = "failure"
    page.eventInfo.eventMsg = status || "failed to update item(s) in cart."
    const otherItems = {}
    if (page.updatedSku) {
      // get productInfo and add to event page objet.
      const matchingSku = page.cart?.item?.find(
        prod =>
          prod.productInfo?.productID?.toLowerCase() ===
          page.updatedSku.toLowerCase()
      )
      if (matchingSku) {
        otherItems.productInfo = matchingSku.productInfo
      }
    }
    otherItems.eventInfo = page.eventInfo
    delete page.eventInfo
    window.adobeDataLayer.push({
      event: "cmp:click",
      page,
      ...otherItems,
    })
  } else if (page.eventInfo && cartObj) {
    calculateCartAnalytics({ itemSkus, cart: cartObj, eventName: "cmp:click" })
  }

  if (window?.pageObj?.updatedSku) {
    delete window.pageObj.updatedSku
  }
  if (window.pageObj) {
    window.pageObj.cart = cartObj
  }

  let windowDataLayer = window.adobeDataLayer
  if (
    windowDataLayer &&
    windowDataLayer.length > 0 &&
    windowDataLayer[0].page
  ) {
    calculateCartAnalytics({ itemSkus, cart: cartObj })
    windowDataLayer = window.adobeDataLayer
    const winDataLayer = windowDataLayer[windowDataLayer.length]
    if (
      windowDataLayer.length > 1 &&
      winDataLayer &&
      winDataLayer.event &&
      (winDataLayer.event === "cmp:show" ||
        winDataLayer.event === "cmp:click") &&
      winDataLayer.page &&
      !winDataLayer.page.cart
    ) {
      winDataLayer.page.cart = cartObj
    }
  }
}

export const calculateCartAnalytics = async data => {
  const { itemSkus, cart: cartData, eventName = "cmp:show" } = data
  const cart = await mapCollapsedSku({ itemSkus, cart: cartData })

  const page = window.pageObj || {}

  page.cart = { cart }
  page.user = getUserAnalyticsObject()
  if (
    eventName === "cmp:show" &&
    page.user &&
    (!page.user.gId || page.user.gId === "n/a") &&
    (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")
  ) {
    window.pageObj = page
    window.isShowAnalyticsEvent = true
  } else if (
    (eventName === "cmp:show" && !isShowAnalyticsEventLoaded()) ||
    eventName !== "cmp:show"
  ) {
    let otherItems = {}
    if (eventName !== "cmp:show") {
      if (page.eventInfo) {
        otherItems = { eventInfo: page.eventInfo }
        delete page.eventInfo
      }
      const matchedItem = cart?.item?.find(
        prod => prod.productInfo?.productUpdated === true
      )
      if (matchedItem) {
        // here check initialQuantity from oldCart object.

        if (window.oldValue) {
          matchedItem.productInfo.initialQuantity = window.oldValue
          delete window.oldValue
        }
        otherItems.productInfo = matchedItem.productInfo
      }
    }

    window.adobeDataLayer.push({
      event: eventName,
      page,
      ...otherItems,
    })
  }
}

export const addCartItemSummaryAnalytics = (
  page,
  prodDesc,
  prodName,
  pdpNavigationURL,
  isBundleParent = ""
) => {
  const isBundleProduct =
    (isBundleParent && page === "cart") ||
    (isBundleParent && page === "checkout") ||
    (isBundleParent && page === "pdp")
      ? ":bundle"
      : ""
  return JSON.stringify({
    clickInternalLinks: "true",
    eventAction: `${
      page !== "cart" && page !== "checkout" && page !== "pdp"
        ? "my account:orders:order summary"
        : page === "cart"
        ? "cart preview"
        : page
    }:product navigation`,
    eventMsg: "n/a",
    eventName: `${
      page !== "cart" && page !== "checkout" && page !== "pdp"
        ? "my account:orders:order summary"
        : page === "cart"
        ? "cart preview"
        : page
    }:product navigation`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: sanitizeTextForAnalytics(prodName || prodDesc), // populate with the actual link name
    internalLinkPosition:
      page !== "cart" && page !== "checkout" && page !== "pdp"
        ? "my account"
        : page + isBundleProduct,
    internalLinkType: `${
      page !== "cart" && page !== "checkout" && page !== "pdp"
        ? "my account"
        : page
    }:navigation`,
    internalLinkURL: pdpNavigationURL
      ? (pdpNavigationURL?.indexOf("http") === -1
          ? window.location.origin
          : "") + pdpNavigationURL
      : "n/a",
    internalLinkZoneName:
      page !== "cart" && page !== "checkout" && page !== "pdp"
        ? "my account:orders:order summary"
        : page + ":preview",
  })
}

export const addRemoveProductFromCartAnalytics = (
  action,
  isBundleParent = "",
  cartItemProductInfo
) => {
  const eventInfo = {
    eventAction: "cart:landing page:remove",
    eventName: "cart:landing page:remove",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "remove",
    internalLinkPosition: `cart${isBundleParent ? ":bundle" : ""}`,
    internalLinkType: "cart:navigation",
    internalLinkZoneName: "cart:landing page:cart items",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }

  sessionStorage.setItem("cartLanding", eventInfo.searchCount)
  const page = window.pageObj || {}
  window.adobeDataLayer.push({
    event: action,
    page,
    eventInfo,
    productInfo: cartItemProductInfo?.productInfo,
  })
}
export const addDatalayer = params => {
  const {
    section = null,
    title = null,
    productInfo = null,
    calculatedValues = null,
    sqaureFeetSelection = null,
    tooltipVal = null,
  } = params

  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const componentName = page?.category?.subCategoryID

  const productInfoJSON =
    productInfo?.length > 0 ? { productInfo: JSON.parse(productInfo) } : null

  const getcalculatedValues =
    calculatedValues?.length > 0 ? JSON.parse(calculatedValues) : null

  let internalLinkName
  let internalLinkType

  if (title === `recalculate footage`) {
    internalLinkName = "recalculate"
    internalLinkType = `${componentName}:navigation`
  } else if (title === `calculate footage`) {
    internalLinkName = sqaureFeetSelection
      ? "square feet changed"
      : "overage selection"
  } else if (title === `info icon mouseover`) {
    internalLinkName = tooltipVal
    internalLinkType = `${componentName}:mouseover`
  }

  const eventInfo = {
    eventAction: `${componentName}:landing page:${section}:${title}`,
    eventName: `${componentName}:landing page:${section}:${title}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: internalLinkName || `${title}`,
    internalLinkPosition: `${componentName}`,
    internalLinkType: internalLinkType || `${componentName}:${title}`,
    internalLinkZoneName: `${componentName}:landing page:${section}`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    ...getcalculatedValues,
  }

  window.adobeDataLayer.push({
    event: "cmp:click",
    page,
    eventInfo,
    ...productInfoJSON,
  })
}

export const addSharedCartItemSummaryAnalytics = (
  page = "",
  subpage = "",
  prodDesc = "",
  prodName = "",
  pdpNavigationURL = "",
  isBundleParent = false
) => {
  const isBundleProduct = isBundleParent ? ":bundle" : ""
  const landingPageInfo = `${page}:${PAGE_TYPES?.SHARE_CART_LANDING_PAGE}`
  const shareCartPage = `${landingPageInfo}:${NAVIGATION_TYPE.PRODUCT}`
  return JSON.stringify({
    clickInternalLinks: "true",
    eventAction: shareCartPage,
    eventMsg: "n/a",
    eventName: shareCartPage,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: sanitizeTextForAnalytics(prodName || prodDesc),
    internalLinkPosition: subpage + isBundleProduct,
    internalLinkType: `${subpage}:navigation`,
    internalLinkURL: pdpNavigationURL
      ? (pdpNavigationURL?.indexOf("http") === -1
          ? window.location.origin
          : "") + pdpNavigationURL
      : "n/a",
    internalLinkZoneName: landingPageInfo,
  })
}
